import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface EmptyStateProps {
  title?: string;
  message?: string;
  buttonText?: string;
  buttonLink?: string;
  hideButton?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = "Oops",
  message = "Something happened",
  buttonText = "",
  buttonLink = "/",
  hideButton = false,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(buttonLink);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: "60px 16px", md: "120px 32px" },
        gap: 4,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        flex: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src="/images/moon.png"
          alt="Empty State"
          sx={{
            width: { xs: 200, md: 260 },
            height: { xs: 200, md: 260 },
          }}
        />
        <Box
          sx={{
            ml: { xs: 0, md: -15 },
            mt: { xs: -5, md: 0 },
            zIndex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: { xs: "100%", md: "400px" },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: "40px",
              fontWeight: 700,
              color: theme.palette.primary.main,
              textAlign: "left",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: theme.palette.primary.main,
              textAlign: "left",
              mt: 1,
            }}
          >
            {message}
          </Typography>
        </Box>
      </Box>

      {!hideButton && (
        <Button
          variant="contained"
          onClick={handleButtonClick}
          endIcon={<ArrowForward />}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: "50px",
            padding: "12px 24px",
            fontSize: "18px",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)",
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;
